import { IOnInit } from "angular";
import * as angular from 'angular';
import { FeesRepo } from '../../fees.repo'
import { FeeType, FeeTier } from '../../models/fee.models'
import { bool } from "aws-sdk/clients/signer";

class AddFeeTypeDialogController {


  public feeType: FeeType;
  public feeTypeForm: ng.IFormController;
  public isLoading: bool = false;

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private notifyjs, private feesRepo: FeesRepo) {

  }

  cancel = () => {
    this.$mdDialog.cancel();
  }

  getNewFeeTier = (prevFeeTier?: FeeTier) => {
    let feeTier: FeeTier = {
      id: 0,
      high: null,
      low: 0,
      value: null
    };
    if (prevFeeTier) {
      feeTier.low = prevFeeTier.high;
    }
    return feeTier
  }


  addRemoveTiers = () => {
    if (this.feeType.isTiered && (!this.feeType.feeTiers || this.feeType.feeTiers.length == 0)) {
      this.feeType.feeTiers = [];
      this.feeType.feeTiers.push(this.getNewFeeTier(null));
    }
  }

  addFeeTier = () => {
    let prevFeeTier: FeeTier;
    if (this.feeType.feeTiers) {
      prevFeeTier = this.feeType.feeTiers ? this.feeType.feeTiers[this.feeType.feeTiers.length - 1] : null
    }
    this.feeType.feeTiers.push(this.getNewFeeTier(prevFeeTier))
  }


  adjustNextTierLowValue = (currentFeeTier: FeeTier) => {
    let currentFeeTierIndex: number = this.feeType.feeTiers.indexOf(currentFeeTier);
    if (currentFeeTierIndex > -1 && currentFeeTierIndex < this.feeType.feeTiers.length - 1) {
      this.feeType.feeTiers[currentFeeTierIndex + 1].low = currentFeeTier.high;
    }
  }

  removeTier = (currentFeeTier: FeeTier) => {
    let currentFeeTierIndex: number = this.feeType.feeTiers.indexOf(currentFeeTier);
    if (currentFeeTierIndex > 0) {
      this.feeType.feeTiers.splice(currentFeeTierIndex, 1)
      this.adjustNextTierLowValue(this.feeType.feeTiers[currentFeeTierIndex - 1])
      this.adjustNextTierLowValue(this.feeType.feeTiers[currentFeeTierIndex])
    }
  }

  getFeeTierHighValueLimit = (feeTier: FeeTier) => {
    let currentFeeTierIndex: number = this.feeType.feeTiers.indexOf(feeTier);
    if (currentFeeTierIndex > -1 && this.feeType.feeTiers.length - 1 > currentFeeTierIndex) {
      return feeTier.low + 1;
    } else if (currentFeeTierIndex === this.feeType.feeTiers.length - 1) {
      return 0
    }
  }

  isHighTierValueRequired = (feeTier: FeeTier) => {
    let currentFeeTierIndex: number = this.feeType.feeTiers.indexOf(feeTier);
    return currentFeeTierIndex !== this.feeType.feeTiers.length - 1 ;
  }

  enableAddTierButton = () => {
    return this.feeType.feeTiers[this.feeType.feeTiers.length - 1].high
  }


  save = () => {
    this.isLoading = true;
    let feeTypePayload: FeeType = this.feeType;
    feeTypePayload = angular.copy(this.feeType);
    if (!this.feeType.isTiered) {
      this.feeType.feeTiers = [];
    } else {
      let feeTiers: Array<FeeTier> = this.feeType.feeTiers.map(ft => {
        return {
          low: ft.low,
          high: ft.high == null ? 0 : ft.high,
          value: ft.value / 100,
          id: -1
        }
      })

      feeTypePayload.feeTiers = feeTiers;
    }

    if(feeTypePayload.id){
      this.editFeeType(feeTypePayload);
    }else{
      this.feesRepo.saveFeeType(feeTypePayload)
        .then(res => {
          this.isLoading = false;
          this.$mdDialog.hide(true)
        })
        .catch(err => {
          this.isLoading = false;
          this.notifyjs(`Failed to save fee type  - ${err.data}`, 'error')
        })
    }


  }

  editFeeType = (feeType : FeeType) => {
    this.feesRepo.editFeeType(feeType)
    .then(res => {
      this.isLoading = false;
      this.$mdDialog.hide(true)
    })
    .catch(err => {
      this.isLoading = false;
      this.notifyjs(`Failed to save fee type  - ${err.data}`, 'error')
    })
  }


}

export const addFeeTypeDialog: angular.IComponentOptions = {
  template: require('./addFeeType.dialog.html'),
  controller: AddFeeTypeDialogController,
  bindings: {
    feeType: "<",
  }
}



// WEBPACK FOOTER //
// ./src/app/fees/feeTypeManagement/addFeeTypeDialog/addFeeType.dialog.ts